import { useContext, memo, PropsWithChildren } from 'react';
import DiagramTooltip from '../Generic/diagramTooltip';
import { TooltipContext } from '../Providers/tooltipContext';
import { HotSpot } from 'Guide/Schematics/Diagram/Providers/dataContext';
import { DiagramElementContext } from 'Guide/Schematics/Diagram/Providers/diagramElementContext';
import HotspotTooltipContent from './lightBoxTooltipContent';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';

function HotspotTooltip({
   data,
   children,
   visible,
}: PropsWithChildren<{
   data: HotSpot<iFixitHotSpotItem>;
   visible: boolean;
}>) {
   const tooltipContext = useContext(TooltipContext);
   const elementContext = useContext(DiagramElementContext);

   if (!visible) {
      return <>{children}</>;
   }

   const onHide = () => {
      tooltipContext.setOpenDataPointId(currentlyOpenId =>
         currentlyOpenId == data.id ? null : currentlyOpenId
      );
   };

   const appendTo = () => elementContext.SVGWrapperRef.current;

   return (
      <DiagramTooltip
         defaultIsOpen={visible}
         isOpen={visible}
         content={<HotspotTooltipContent data={data} />}
         isLazy={true}
         onClose={onHide}
         closeOnBlur={false}
         autoFocus={false}
         contentProps={{
            maxWidth: 'min(calc(100vw - 20px), 600px)',
         }}
         appendTo={appendTo}
      >
         {children}
      </DiagramTooltip>
   );
}

export default memo(HotspotTooltip);
